import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle, Instagram, Facebook } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/", label: "Início" },
  { to: "/sobre", label: "Sobre" },
  { to: "/servicos", label: "Serviços" },
  { to: "/tecnologias", label: "Tecnologias" },
  { to: "/projetos", label: "Projetos" },
  { to: "/contato", label: "Contato" },
];

const SERVICES = [
  { to: "/servicos#windows-linux", label: "Windows Server & Linux" },
  { to: "/servicos#directory-dns", label: "Active Directory & GPO" },
  { to: "/servicos#azure-cloud", label: "Azure & Migração Híbrida" },
  { to: "/servicos#networks-security", label: "Redes, Firewalls & VPNs" },
  { to: "/servicos#backup-continuity", label: "Backup & Continuidade" },
];

export default function Footer() {
  return (
    <footer className="bg-graphite text-white" data-testid="site-footer">
      <div className="container-x py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Logo variant="light" testId="footer-logo" />
            <p className="mt-5 text-sm leading-relaxed text-white/60 max-w-xs">
              Consultoria, implementação, administração, modernização e suporte de infraestrutura de TI corporativa.
            </p>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Navegação</p>
            <ul className="mt-4 space-y-2.5">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/70 hover:text-techblue transition-colors duration-200">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Serviços</p>
            <ul className="mt-4 space-y-2.5">
              {SERVICES.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/70 hover:text-techblue transition-colors duration-200">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Contato</p>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 mt-0.5 text-techblue shrink-0" />
                <a href="mailto:contato@iprsinf.com.br" data-testid="footer-email-link" className="hover:text-techblue transition-colors duration-200">
                  contato@iprsinf.com.br
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Phone className="w-4 h-4 mt-0.5 text-techblue shrink-0" />
                <a href="tel:+5521991592603" data-testid="footer-phone-link" className="hover:text-techblue transition-colors duration-200">
                  +55 (21) 99159-2603
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <MessageCircle className="w-4 h-4 mt-0.5 text-techblue shrink-0" />
                <a
                  href="https://wa.me/5521991592603"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="hover:text-techblue transition-colors duration-200"
                >
                  WhatsApp +55 (21) 99159-2603
                </a>
              </li>
              <li className="flex items-center gap-4 pt-1">
                <a
                  href="https://www.instagram.com/iprssolucoes/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram da IPRS Soluções em TI"
                  data-testid="footer-social-instagram"
                  className="text-white/50 hover:text-techblue transition-colors duration-200"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a
                  href="https://web.facebook.com/iprsinfo"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook da IPRS Soluções em TI"
                  data-testid="footer-social-facebook"
                  className="text-white/50 hover:text-techblue transition-colors duration-200"
                >
                  <Facebook className="w-5 h-5" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} IPRS Soluções em TI. Todos os direitos reservados.
          </p>
          <Link
            to="/politica-de-privacidade"
            data-testid="privacy-policy-link"
            className="text-xs text-white/60 hover:text-techblue transition-colors duration-200"
          >
            Política de Privacidade
          </Link>
        </div>
      </div>
    </footer>
  );
}
